import { createAsyncThunk } from '@reduxjs/toolkit';
import { buildingsSchema, buildingType } from '../model/types';
import { apiRequest, createCorsAwareRequest } from '@shared/api/corsProxy';
import z from 'zod';

const dataSchema = z.object({
  id: z.string().optional(),
  buildings: buildingsSchema,
});
interface Data {
  data: {
    id: string | undefined;
    buildings: buildingType[];
  };
}
export const fetchBuildings = createAsyncThunk<
  buildingType[],
  void,
  {
    rejectValue: string;
  }
>('knowledge/fetchBuildings', async (_, { rejectWithValue }) => {
  try {
    const response = await apiRequest<Data>(
      '/data/v2/type?type=commerce&keys=buildings'
    );
    // 'https://api.krasota.agency/data/v2/type?type=commerce&keys=buildings'
    // Handle case where data might be at root level or nested
    const dataToValidate = response?.data || response?.data;
    const parsed = dataSchema.safeParse(dataToValidate);
    if (!parsed.success) {
      console.error(parsed.error.format());
      return rejectWithValue('Ошибка валидации данных с сервера');
    }

    return parsed.data.buildings;
  } catch (error: any) {
    return rejectWithValue(error?.message || 'Ошибка загрузки данных');
  }
});
